import React, { useState } from 'react';

const MONITOR_OPTIONS = [
  { value:'single',  label:'Single Monitor',    desc:'One screen in front of you' },
  { value:'dual',    label:'Dual Side-by-Side', desc:'Two monitors left/right' },
  { value:'triple',  label:'Triple Monitors',   desc:'Three monitors side by side' },
  { value:'stacked', label:'Stacked',           desc:'Portrait screen mounted above laptop' },
];

export function SettingsPanel({ settings, onSave, onClose }) {
  const [local, setLocal] = useState({ ...settings });

  const set = (k, v) => setLocal(p => ({ ...p, [k]: v }));

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300, padding:20 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:16, padding:'28px 28px 24px', maxWidth:420, width:'100%', maxHeight:'90vh', overflowY:'auto' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <div style={{ fontFamily:"'Fraunces',serif", fontSize:'1.2rem' }}>Settings</div>
          <button onClick={onClose} style={{ background:'transparent', border:'none', color:'var(--muted)', fontSize:'1.2rem', cursor:'pointer' }}>✕</button>
        </div>

        <Section label="Monitor Setup">
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {MONITOR_OPTIONS.map(opt => (
              <label key={opt.value} style={{ display:'flex', gap:12, alignItems:'center', padding:'10px 12px', borderRadius:8, border:`1px solid ${local.monitorSetup===opt.value?'var(--accent)':'var(--border)'}`, background: local.monitorSetup===opt.value?'rgba(200,240,96,0.06)':'transparent', cursor:'pointer' }}>
                <input type="radio" name="monitor" value={opt.value} checked={local.monitorSetup===opt.value} onChange={() => set('monitorSetup', opt.value)} style={{ accentColor:'var(--accent)' }} />
                <div>
                  <div style={{ fontSize:'0.74rem', color:'var(--text)' }}>{opt.label}</div>
                  <div style={{ fontSize:'0.62rem', color:'var(--muted)', marginTop:2 }}>{opt.desc}</div>
                </div>
              </label>
            ))}
          </div>
        </Section>

        <div style={{ display:'flex', gap:10, marginTop:24 }}>
          <button onClick={() => { onSave(local); onClose(); }} style={{ flex:1, padding:'10px 0', borderRadius:8, border:'none', background:'var(--accent)', color:'#0a0a0f', fontFamily:"'Nunito',sans-serif", fontSize:'0.74rem', cursor:'pointer', fontWeight:600 }}>
            Save Settings
          </button>
          <button onClick={onClose} style={{ padding:'10px 18px', borderRadius:8, border:'1px solid var(--border)', background:'transparent', color:'var(--text)', fontFamily:"'Nunito',sans-serif", fontSize:'0.74rem', cursor:'pointer' }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

function Section({ label, children }) {
  return (
    <div style={{ marginBottom:20 }}>
      <div style={{ fontSize:'0.6rem', letterSpacing:'0.13em', textTransform:'uppercase', color:'var(--muted)', marginBottom:10 }}>{label}</div>
      {children}
    </div>
  );
}
